/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { remoteSessionClientsList } from "../funcs/remoteSessionClientsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListRemoteSessionClientsRequest,
  ListRemoteSessionClientsResponse,
  ListRemoteSessionClientsSecurity,
} from "../models/operations/listremotesessionclients.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type RemoteSessionClientsQueryData = ListRemoteSessionClientsResponse;

export type RemoteSessionClientsInfiniteQueryData = PageIterator<
  ListRemoteSessionClientsResponse,
  { cursor: string }
>;

export type RemoteSessionClientsPageParams = PageIterator<
  ListRemoteSessionClientsResponse,
  { cursor: string }
>["~next"];

export function prefetchRemoteSessionClients(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListRemoteSessionClientsRequest | undefined,
  security?: ListRemoteSessionClientsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRemoteSessionClientsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchRemoteSessionClientsInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListRemoteSessionClientsRequest | undefined,
  security?: ListRemoteSessionClientsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildRemoteSessionClientsInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as RemoteSessionClientsPageParams,
    getNextPageParam: (previousPage: RemoteSessionClientsInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildRemoteSessionClientsQuery(
  client$: GramCore,
  request?: ListRemoteSessionClientsRequest | undefined,
  security?: ListRemoteSessionClientsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RemoteSessionClientsQueryData>;
} {
  return {
    queryKey: queryKeyRemoteSessionClients({
      remoteSessionIssuerId: request?.remoteSessionIssuerId,
      userSessionIssuerId: request?.userSessionIssuerId,
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function remoteSessionClientsQueryFn(
      ctx,
    ): Promise<RemoteSessionClientsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(remoteSessionClientsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildRemoteSessionClientsInfiniteQuery(
  client$: GramCore,
  request?: ListRemoteSessionClientsRequest | undefined,
  security?: ListRemoteSessionClientsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, RemoteSessionClientsPageParams>,
  ) => Promise<RemoteSessionClientsInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyRemoteSessionClientsInfinite({
      remoteSessionIssuerId: request?.remoteSessionIssuerId,
      userSessionIssuerId: request?.userSessionIssuerId,
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function remoteSessionClientsQuery(
      ctx,
    ): Promise<RemoteSessionClientsInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(remoteSessionClientsList(
          client$,
          request,
          security,
          mergedOptions,
        ));
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(remoteSessionClientsList(
        client$,
        {
          ...request!,
          cursor: ctx.pageParam.cursor,
        },
        security,
        mergedOptions,
      ));
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyRemoteSessionClients(
  parameters: {
    remoteSessionIssuerId?: string | undefined;
    userSessionIssuerId?: string | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "remoteSessionClients", "list", parameters];
}

export function queryKeyRemoteSessionClientsInfinite(
  parameters: {
    remoteSessionIssuerId?: string | undefined;
    userSessionIssuerId?: string | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "remoteSessionClients",
    "list",
    "infinite",
    parameters,
  ];
}
